

const FechaLargaFilter = (filter, fechaConfig, moment) => {

    return  (input) => {

        if (input == null) { return ''; }

        return filter('date')(moment(input).format('LL'));
    };
}

FechaLargaFilter.$inject = ['$filter', 'fechaConfig','moment'];

export default FechaLargaFilter;




// WEBPACK FOOTER //
// ./src/busqueda/filtros/fechalarga.filter.js